import { PageRoots } from '@provision/portal-routes';

// Includes top-level routes (starts with forward slash) only as it should
// permit all nested routes as well.
export const TABS_ENABLED_ON_ROUTES = [
  PageRoots.conversation,
  PageRoots.site,
  PageRoots.client,
  PageRoots.views,
  PageRoots.search,
  PageRoots.view,
  PageRoots.inbox,
];
